/* @flow */

import React from "react";
import { SuccessView as SuccessViewExt } from "@crossroads/shop-views";
import { useAnalytics } from "context/analytics";
import { useClient } from "entrypoint/shared";
import { OrderData } from "data";
import { useData } from "crustate/react";
import { load as loadOrder } from "state/order";
import useFormat from "helpers/use-format";
import { useTranslate } from "@awardit/react-use-translate";
import CheckIcon from "icons/checkmark-success.svg";

const SuccessView = (): React$Node => {
  const orderData = useData(OrderData);
  const { formatPrice } = useFormat();
  const analytics = useAnalytics();
  const t = useTranslate();

  return (
    <SuccessViewExt
      hasRegretPurchaseButton
      orderData={orderData}
      useClient={useClient}
      analytics={analytics}
      formatPrice={formatPrice}
      loadOrder={loadOrder}
      additionalField="PHONE"
      CheckIcon={<CheckIcon aria-label={t("ICONS.CHECK")} style={{ color: "#fff" }} />}
    />
  );
};

export default SuccessView;
